import { ExError } from './ExError';

export const invalidOrExpiredClerkTokenErrorCode = 'CLERK_TOKEN_INVALID_OR_EXPIRED';
export const invalidOrExpiredClerkTokenErrorMessage = 'Invalid or expired token.';

export class ApiExError extends ExError {
  public publicCode: string | undefined;

  constructor(
    public statusCode: string,
    staticMessage: string,
    metadata: ObjectMap<unknown>,
    cause?: unknown,
  ) {
    super(
      staticMessage,
      {
        statusCode,
        ...metadata,
      },
      cause,
    );
  }

  withPublicCode(publicCode: string): this {
    this.publicCode = publicCode;
    return this;
  }

  static wrapApiOrAddMetadata(
    statusCode: string,
    staticMessage: string,
    metadata: ObjectMap<unknown>,
    cause: ExError | unknown,
  ): ApiExError {
    if (cause instanceof ApiExError) {
      return cause.addMetadata(metadata);
    }

    return new ApiExError(statusCode, staticMessage, metadata, cause);
  }
}
